<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Edit Patient",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Patient",
            items: [
               {
                  text: "Patients",
                  href: "/patients",
               },
               {
                  text: "Edit Patient",
                  active: true,
               },        
            ],

            patient: {
               id: null,
               name: 'Peter John',
               dob: '1998-11-11',
               country_code: '91',
               mobile: '9110011001',
               email: 'peter@xyz.com',
               address: 'Vaikam',
               pincode: '680456',
               gender_id: 1,
               
            },

         };
      },
      mounted() {
    
      },
      methods:{
         updatePatient() {
            this.$router.push({ name: 'patients'});
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'patients' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form"  @submit.prevent="updatePatient()">
                        <div class="row">
                           <div class="form-group col-md-4">
                              <label>Name <span class="text-danger">*</span></label>
                              <input type="text" class="form-control" v-model="patient.name"/>
                           </div>                     
                           
                           <div class="form-group col-md-4">
                              <label>Mobile <span class="text-danger">*</span></label>
                              <b-input-group>
                                  <b-input-group-prepend>
                                       <select class="form-control" v-model="patient.country_code">
                                          <option value="91">91</option>
                                          <option value="971">971</option>
                                       </select>
                                  </b-input-group-prepend>
                                  <b-form-input v-model="patient.mobile"></b-form-input>
                              </b-input-group>
                           </div>

                           <div class="form-group col-md-4">
                              <label>Email</label>
                              <input type="email" class="form-control" v-model="patient.email"/>
                           </div>

                           <div class="form-group col-md-4">
                              <label>Date of Birth <span class="text-danger">*</span></label>
                              <input type="date" class="form-control" v-model="patient.dob"/>
                           </div>   

                           <div class="form-group col-md-4">
                              <label>Gender <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="patient.gender_id">
                                 <option value="1">Male</option>
                                 <option value="2">Female</option>
                                 <option value="3">Others</option>
                              </select>
                           </div>   

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Pincode</label>
                              <b-form-input v-model="patient.pincode"  maxlength="6"></b-form-input>
                           </b-form-group>

                           <b-form-group class="col-lg-12 mb-3">
                              <label>Address <span class="text-danger">*</span></label>
                              <b-form-textarea v-model="patient.address"></b-form-textarea>
                           </b-form-group>

                                                                           
                        </div>

                        <div class="row">

                           <b-form-group class="col-lg-12">
                              <label>Profile Image <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label><br>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" />
                              <p class="small">(Leave this field empty if you don't want to change the image)</p>
                              <!-- <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image"> -->

                              <!-- <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> -->
                           </b-form-group>                                                                      
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Update</button>
                              <router-link :to="{ name: 'patients' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
